export default {
  black: "#000000",
  offVlack: "#171717",
  red: "#EB3A06",
  grey: "#F8F8F8",
  darkGrey: "#2B2B2B",
}
